import {useEffect, useRef} from 'react'
import {devMode} from "../libs/isDevMode";


export const useDidUpdateEffect = (effect, deps) => {
    if (devMode) {
        if (deps !== undefined && !Array.isArray(deps)) {
            throw new Error('Deps should be an Array');
        }
    }

    const didMountRef = useRef(false);

    useEffect(() => {
        if (didMountRef.current)
            return effect();
        else
            didMountRef.current = true;
        // eslint-disable-next-line
    }, deps);
}